import React, { useState } from 'react';

import { Modal } from '@eika/modal';
import { Tabs } from '@eika/tabs';

import { useSigningContext } from '@/domain/signing';

import { CreditCard, CreditCardAccount } from '@generated-types';

import { PaymentForm } from '../PaymentForm';
import { TransferForm } from '../TransferForm';

import './CardPaymentModal.scss';

type CardPaymentModalProps = {
    card: CreditCard;
    account: CreditCardAccount;
    setOpenModal(val: boolean): void;
};

export const CardPaymentModal = ({ setOpenModal, card, account }: CardPaymentModalProps) => {
    const [selected, setSelected] = useState('Betal');
    const { status } = useSigningContext();

    return (
        <Modal open setOpen={setOpenModal} className="card-payment-modal">
            {!status && (
                <div className="card-payment-modal__tabs-wrapper">
                    <Tabs onChangeValue={setSelected} removeHiddenTabsFromDom>
                        <Tabs.TabList>
                            <Tabs.TabButton value="Betal">Betal</Tabs.TabButton>
                            <Tabs.TabButton value="Overfør">Overfør</Tabs.TabButton>
                        </Tabs.TabList>
                    </Tabs>
                </div>
            )}
            {selected === 'Betal' && <PaymentForm card={card} account={account} setOpen={setOpenModal} />}
            {selected === 'Overfør' && <TransferForm card={card} account={account} setOpen={setOpenModal} />}
        </Modal>
    );
};
